<template>
<div v-if='!forceHideMap'
     class='qa-event-preview-popup h-flex h-height-100p h-flex-dir-column h-flex-space-between'>
    <div v-if='mapsApi_isGoogleMap'
         ref='map'
         class='h-width-100p b-global-map'
         style='height: 200px;'>
        <FwSpinLoader
            v-if='isMapLoading'
            :colors='["#27dbbd", "#27DBBD", "#27DBBD"]'
            :isActive='isMapLoading'>
        </FwSpinLoader>
    </div>
    <LeafletMap
        v-else-if='mapsApi_isLeafletMap'
        :latitude='latitude'
        :longitude='longitude'
        class='h-width-100p b-global-map'>
    </LeafletMap>
</div>
</template>

<script lang='ts'>
import { Component, mixins, Prop } from 'vue-facing-decorator';
import { LeafletMap } from '@/components/common/LeafletMap';
import GoogleApi from '@/mixins/google-api';
import MapsApi from '@/mixins/maps-api';

@Component({
    components: {
        LeafletMap,
    },
})

export default class GlobalMap extends mixins(MapsApi, GoogleApi) {
    @Prop({ type: Boolean, default: false }) readonly forceHideMap!: boolean;
    @Prop({ type: Number, required: true }) readonly latitude!: number;
    @Prop({ type: Number, required: true }) readonly longitude!: number;

    isMapLoading: boolean = false;
    mapGetParam: string = '';
    google: any = null;

    initMap() {
        if (this.longitude && this.latitude && !this.forceHideMap) {
            if (this.mapsApi_isGoogleMap) {
                try {
                    this.mapGetParam = `sensor=false&language=en&libraries=places`;
                    const callback = () => {
                        if (window.google && window.google.maps) {
                            const mapOptions = {
                                zoom: 16,
                                center: { lat: this.latitude, lng: this.longitude },
                                disableDefaultUI: true,
                                mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                            };
                            const mapView = new window.google.maps.Map((this.$refs.map as HTMLElement), mapOptions as any);

                            const marker = new window.google.maps.Marker({
                                // @ts-ignore-next-line
                                position: { lat: this.latitude, lng: this.longitude },
                                map: mapView,
                            });
                        }
                        this.isMapLoading = false;
                    };
                    this.addGoogleMapsScript({ callback });
                } catch (e) {
                    this.isMapLoading = false;
                    console.log(e);
                }
            }
        }
    }

    async mounted() {
        await this.$nextTick();
        this.initMap();
    }
}
</script>
<style lang='sass'>
.b-global-map
    display: flex
    align-items: center
    justify-content: center
</style>
